/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useCallback } from 'react'
import { useAppProviderContext, useDropOffLocationContext, useMapContext } from '../../core/application/contexts'
import AutocompleteDetails from '../../core/domain/models/AutocompleteDetails'
import AutocompleteSuggestion from '../../core/domain/models/AutocompleteSuggestion'
import SearchInputWrapper from '../shared/SearchInputWrapper'
import { LocationType } from '../../core/domain/models'

interface DropOffLocationSearchInputProps {
  placeholder?: string
}

const DropOffLocationSearchInput: FC<DropOffLocationSearchInputProps> = (props) => {
  const { placeholder } = props
  const { setCurrentDropOffLocation } = useDropOffLocationContext()
  const { dropOffProvider, multisearchProvider } = useAppProviderContext()
  const { panTo } = useMapContext()

  const onSelect = useCallback((suggestion: AutocompleteSuggestion, callback: () => void) => {

    if (suggestion.api === 'store') {
      dropOffProvider?.fetchDropOffByStoreId(suggestion.id).then((dropOff) => {
        if (dropOff) {
          setCurrentDropOffLocation(dropOff)
          callback()
        }
      })
    } else {
      const { api, id } = suggestion
      multisearchProvider?.detailsMulti({ api, id }).then((details: AutocompleteDetails | null) => {
        if (details) {
          let locationType: LocationType = 'poi'
          if (details.types.includes('locality')) {
            locationType = 'city'
          } else if (details.types.includes('country')) {
            locationType = 'country'
          }
          const { location } = details.geometry
          panTo({
            ...location,
            locationType
          })
          callback()
        }
      })
    }
  }, [])

  return <SearchInputWrapper placeholder={placeholder} onSelect={onSelect} />
}

export default DropOffLocationSearchInput
